import { BObject } from "../BObject";

export class BObjectProvider{
    private bObjects : Array<BObject>

    constructor(){
        this.bObjects = new Array<BObject>();
    }

    add(newObj: BObject){
        this.bObjects.unshift(newObj); //so that object is on top of the previously added objects. Array index represents the layer depth. 
    }

    getObjects(){
        return this.bObjects;
    }

    getCount(){
        return this.bObjects.length;
    }

    getObject(index: number): BObject|null{
        if(index < this.getCount()){
            return this.bObjects[index]
        }
        return null;
    }

    getObjectById(id: number): BObject|null{
        for(let object of this.bObjects){
            if(object.getId() == id){
                return object;
            }
        }
        return null;
    }

    deleteObjectByIndex(index: number){
        this.bObjects.splice(index, 1);
    }

    deleteObject(objToDel: BObject){
        let index = this.getObjects().indexOf(objToDel, 0);
        if(index!=-1){
            console.log("Deleting obj:"+index);
            this.deleteObjectByIndex(index);
        }
    }

    shiftBy(index: number, moveBy: number){
        if(index != -1){
            let selObj : BObject = this.bObjects.splice(index, 1)[0];
            this.bObjects.splice(index+moveBy, 0, selObj);
        }
    }
}